export default __webpack_public_path__ + "static/lokal-0836f8f1e815459cf581ffc5970c2df4.jpg";